import type {
  InitGameOptions,
  OblivionMinePlayer,
  OblivionMinePlayerId,
  OblivionMineState,
  OblivionMineTreasure,
} from "./types";
import {
  OBLIVION_MINE_PLAYERS,
  OBLIVION_MINE_STARTS,
  OBLIVION_MINE_TREASURE_CELLS,
} from "./types";

function createPlayer(playerId: OblivionMinePlayerId): OblivionMinePlayer {
  return {
    playerId,
    label: playerId === "p1" ? "흑 탐험가" : "백 탐험가",
  };
}

function createTreasures(): readonly OblivionMineTreasure[] {
  return OBLIVION_MINE_TREASURE_CELLS.map((cell) => ({
    row: cell.row,
    col: cell.col,
    collectedBy: null,
  }));
}

function assertPlayerId(playerId: OblivionMinePlayerId, context: string): void {
  if (!OBLIVION_MINE_PLAYERS.includes(playerId)) {
    throw new Error(`${context} must be p1 or p2`);
  }
}

export function initGame(options: InitGameOptions = {}): OblivionMineState {
  if (options.firstPlayerId) {
    assertPlayerId(options.firstPlayerId, "First player");
  }
  // p1 (black) lays and moves first by default.
  const firstPlayerId = options.firstPlayerId ?? "p1";

  return {
    gameId:
      options.gameId ?? `oblivion-mine-${OBLIVION_MINE_PLAYERS.join("-")}`,
    players: OBLIVION_MINE_PLAYERS.map(createPlayer),
    phase: "lay-mines",
    mines: [],
    positions: {
      p1: OBLIVION_MINE_STARTS.p1,
      p2: OBLIVION_MINE_STARTS.p2,
    },
    treasures: createTreasures(),
    minesLaid: { p1: false, p2: false },
    scores: { p1: 0, p2: 0 },
    firstPlayerId,
    currentPlayerId: firstPlayerId,
    moveNumber: 0,
    lastHit: null,
    winnerId: null,
    lastAction: null,
  };
}
